var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressIcon = function SvgAddressIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.068 2.831a6.458 6.458 0 1 0-9.133 9.133l3.859 3.86a1 1 0 0 0 1.414 0l3.86-3.86a6.46 6.46 0 0 0 0-9.133m-8.426.707a5.458 5.458 0 1 1 7.719 7.719l-3.86 3.86-3.86-3.86a5.46 5.46 0 0 1 0-7.719m1.95 3.86a1.907 1.907 0 1 1 3.816 0 1.907 1.907 0 0 1-3.815 0M7.5 4.491a2.907 2.907 0 1 0 0 5.815 2.907 2.907 0 0 0 0-5.815",
    clipRule: "evenodd"
  })));
};
export default SvgAddressIcon;